export class CtnModel {
    ctnNumber: number;
    status: string;
    model: string;
    userName: string;
    selected?: boolean;
}
